<template>
  <span class="app-send-verification-mail" v-if="!currentCustomer.emailVerified">
       <b-row class="emailState">
          <b-col md="" sm="12" class="label">
            <slot name="lblEmailState">E-Mail-Status</slot>
          </b-col>
          <b-col md="" sm="12" class="value">Bestätigung ausstehend</b-col>
      </b-row>
      <span class="send-verification-email-btn">
        <b-row class="txtAfter">
          <b-col md="" sm="12" class="empty">
            <slot name="empty"></slot>
          </b-col>
          <b-col md="" sm="12" class="label">
            <a role="button" v-on:click="sendVerificationEmail" :disabled="loading"><slot name="lblButton">Erneut Senden</slot></a>
          </b-col>
        </b-row>
      </span>
    </span>
  <span class="app-send-verification-mail" v-else>
       <b-row class="emailState">
          <b-col md="" sm="12" class="label">
            <slot name="lblEmailState">E-Mail-Status</slot>
          </b-col>
          <b-col md="" sm="12" class="value">Bestätigt</b-col>
      </b-row>
    </span>
</template>

<script>
import gql from 'graphql-tag'
import { splitError } from '@/helper/splitError'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import transaction from '@/mixins/transaction'
import { mapMutations } from 'vuex'

export default {
  name: 'SendVerificationMail',
  data () {
    return {
      currentCustomer: {
        email: null,
        emailVerified: true
      },
      show: false,
      loading: false
    }
  },
  props: {
    alwaysRedirect: {
      type: Boolean,
      default: false
    },
    link: {
      type: String
    }
  },
  mixins: [
    transaction('sendVerificationEmail')
  ],
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    sendVerificationEmail: function () {
      if (this.loading) {
        return
      }
      this.loading = true
      const me = this
      const graphQlClient = me.$apolloProvider.defaultClient

      graphQlClient.mutate({
        mutation: gql`mutation sendVerificationEmail {
            sendVerificationEmail
        }`
      }).then((response) => {
        this.loading = false
        me.$store.commit('Transaction/removeTransactionId', 'sendVerificationEmail', { root: true })
        if (response.data.sendVerificationEmail === true) {
          if (me.alwaysRedirect) {
            me.$store.commit('personalData/activateShowSendVerificationText')
            window.location.href = me.link
          }
          me.$store.commit('personalData/changeView', 'SendVerificationMail')
          this.markShown()
        } else me.$store.commit('addError', 'Die EMail konnte nicht versendet werden')
      }).catch((error) => {
        this.loading = false
        splitError(error).forEach(e => me.$store.commit('addError', e))
      })
    },
    markShown () {
      this.$store.commit('markModalShown', 'emailVerified')
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(gql`query sendVerificationEmail{
        currentCustomer {
          emailVerified
          email
        }
      }`, this, 'currentCustomer')
    }
  }
}
</script>
